import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';

/* NOTE: We avoid theme tokens (COLORS, GRADIENTS, SCREEN_SIZE)
 * because LoadingSpinner renders before ThemeProvider inside <Suspense fallback>. */
export const LoadingSpinnerContainer = styled.div<{ $isTransparent: boolean }>`
  position: absolute;
  inset: 0;
  z-index: 99999999;
  display: grid;
  grid-template-rows: 1fr 2fr;
  background: ${({ $isTransparent }) =>
    $isTransparent ? 'transparent' : 'linear-gradient(45deg, #3d80c1 0%, #24a360 100%)'};
  max-width: 1080px;
  margin: 0 auto;

  img {
    width: 150px;
    height: 150px;
    object-fit: cover;
  }
`;

export const TextContainer = styled(Flexbox)`
  max-width: 311px;
  color: '#efefef';
`;
